import styles from "./Greetings.module.scss";
import LogoIcon from "../../components/icons/Logo";
import Footer from "../../components/footer/Footer";
import Button from "../../components/shared/Button/Button";
import {useLocation, useNavigate} from "react-router-dom";
import {ROUTES} from "../../constants/routes";
import {useTranslation} from "react-i18next";
import useAccount from "../../hooks/useAccount";
import {useEffect, useState} from "react";
import axiosInstance from "../../api/axios";
const Greetings = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [error, setError] = useState<string>('');
  const queryParams = new URLSearchParams(location.search);

  const billingPeriod = queryParams.get("billing_period");
  const orderId = queryParams.get("order_id");

  const { getAccountDetails } = useAccount();
  const { t } = useTranslation();

  const checkSub = async () => {
    try {
      const response = await axiosInstance.post<any>(`/commercials/order/${orderId}/check`, {});
      if (response.data.order_status === "success") {
        getAccountDetails();
      } else {
        setError('errGreet')
      }
    } catch (e) {
      setError('errGreet')
      console.log(e);
    }

  }

  useEffect(() => {
    checkSub(); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [getAccountDetails]);

  return (
    <>
      <div className={styles.greetingsPageWrapper}>
        <div className={styles.header}><LogoIcon/></div>
        <div className={styles.contentWrapper}>
          <div className={styles.title}>{t('greet4')}</div>
          {error ? (
            <div className={styles.description}>
              {t(error)}
            </div>
          ): (
            <div className={styles.description}>
              {t('greet1')}<br/>
              <span>{billingPeriod !== 'month' ? `"${t('greet2')}"` : `"${t('greet5')}"`}</span>
            </div>
          )}
          <Button
            title={t('greet3')}
            submit={() => navigate(ROUTES.PROFILE)}
            className={styles.btn}
          />
        </div>
        <div style={{height:'50px'}} />
      </div>
      <Footer source={''}/>
    </>

  )
}

export default Greetings;
